import { render, staticRenderFns } from "./RemerasListaItem.vue?vue&type=template&id=4aa1ee31&"
import script from "./RemerasListaItem.vue?vue&type=script&lang=js&"
export * from "./RemerasListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports